'use strict';
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var u2fApi = require("./lib/u2f-api");
__export(require("./lib/u2f-api"));
exports.default = u2fApi;
//# sourceMappingURL=index.js.map